<template>
  <div class="homepage">
    <!-- 第一部分：顶部大图 -->
    <section class="hero-section">
      <img src="@/assets/home/hero.png" alt="主图" class="hero-image" loading="lazy" />
    </section>

    <!-- 第二部分：服务内容 -->
    <section class="services-section">
      <div class="content-wrapper">
        <div class="section-header">
          <h2 class="section-title">原牧欣服务</h2>
          <router-link to="/services" class="more-link">
            <span>了解更多</span>
            <img src="@/assets/icons/arrow-right.png" alt="了解更多" class="more-icon" loading="lazy" />
          </router-link>
        </div>
        <p class="description">
          武汉原牧欣网络科技有限公司，致力于为企业和创新者提供高效、可靠的技术解决方案。我们以技术开发为核心，助力客户实现数字化转型、产品创新与业务增长。
        </p>
        <div class="service-grid">
          <div class="service-item" v-for="(item, index) in serviceImages" :key="index">
            <img :src="item.src" :alt="'服务' + (index + 1)" loading="lazy" />
          </div>
        </div>
      </div>
    </section>

    <!-- 第三部分：关于我们 -->
    <section class="about-section">
      <div class="content-wrapper">
        <div class="section-header">
          <h2 class="section-title">关于我们</h2>
          <router-link to="/about" class="more-link">
            <span>了解更多</span>
            <img src="@/assets/icons/arrow-right.png" alt="了解更多" class="more-icon" loading="lazy" />
          </router-link>
        </div>
        <div class="about-image">
          <img src="@/assets/home/about.png" alt="关于我们" loading="lazy" />
        </div>
      </div>
    </section>
  </div>
</template>

<script setup>
const serviceImages = [
  { src: require('@/assets/home/soft.png') },
  { src: require('@/assets/home/app.png') },
  { src: require('@/assets/home/web.png') },
  { src: require('@/assets/home/mini-program.png') },
  { src: require('@/assets/home/technology-transfer.png') },
  { src: require('@/assets/home/technology-exchange.png') },
]
</script>

<style scoped>
html, body {
  margin: 0;
  padding: 0;
  overflow-x: hidden;
  font-family: Arial, sans-serif;
  color: #333;
}

/* 容器宽度及内边距自适应 */
.content-wrapper {
  width: 80%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 1rem;
}

/* 顶部图像 */
.hero-section {
  width: 100%;
  overflow: hidden;
  margin: 0;
  padding: 0;
}

.hero-image {
  width: 100%;
  height: auto;
  display: block;
}

/* 服务区样式 */
.services-section {
  padding: 2rem 0;
  background-color: #f9f9f9;
}

.section-header {
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;
  margin-bottom: 1rem;
}

.section-header h2 {
  grid-column: 1 / -1;
  font-size: clamp(24px, 4vw, 35px);
  margin: 0 auto;
  text-align: center;
}

.more-link {
  justify-self: end;
  display: flex;
  align-items: center;
  color: #1e5fdd;
  text-decoration: none;
  font-size: clamp(16px, 2vw, 20px);
  white-space: nowrap;
}


.more-link:hover {
  text-decoration: underline;
}

.more-icon {
  width: 1.2rem;
  height: 1.2rem;
  margin-left: 0.4rem;
}

/* 描述文本 */
.description {
  margin: 1rem 0 2rem;
  font-size: clamp(16px, 2vw, 20px);
  line-height: 1.6;
}

/* 服务图片栅格 */
.service-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1rem;
}

.service-item img {
  width: 100%;
  height: auto;
  border-radius: 8px;
  display: block;
}

/* 关于我们 */
.about-section {
  padding: 2rem 0;
  background-color: #fff;
}

.about-image {
  margin-top: 1rem;
  width: 100%;
}

.about-image img {
  width: 100%;
  height: auto;
  border-radius: 8px;
  object-fit: cover;
}

.section-title {
  color: black;
  font-size: clamp(28px, 5vw, 35px);
  font-weight: bold;
  margin-bottom: 1.5rem;
}

/* 响应式调整 */

/* 中屏，tablet */
@media (max-width: 992px) {
  .service-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .section-header {
    align-items: center;
  }

  .more-link {
    font-size: clamp(14px, 2.5vw, 20px);
  }

  .description {
    font-size: clamp(14px, 2.5vw, 20px);
  }
}

/* 小屏，mobile */
@media (max-width: 600px) {
  .service-grid {
    grid-template-columns: 1fr;
  }

  .section-header {
    align-items: center;
  }

  .section-header h2 {
    font-size: clamp(20px, 5vw, 28px);
  }

  .more-link {
    margin-top: 0.5rem;
  }


  .description {
    font-size: clamp(14px, 3vw, 22px);
  }
}
</style>
